<template>
  <div class="create-partner">
    <div class="flex justify-between">
      <div class="text-2xl font-bold mb-6">Creat New Order</div>
      <div class="flex justify-end gap-6">
        <div class="">
          <LinkButton buttonText="Cancel" type="secondary" linkType="internal" url="/" />
        </div>
        <div class="">
          <Button buttonText="Save" type="primary" />
        </div>
      </div>
    </div>
    <div class="border shadow-lg rounded-md bg-white p-6 flex gap-20">
      <div class="flex-1">
        <div class="mb-4">
          <TextField type="text" v-model="payload.name" label="Nama" />
        </div>
        <div class="mb-4">
          <TextField type="text" v-model="payload.email" label="Email" />
        </div>
      </div>
      <div class="flex-1">
        <div class="mb-4">
          <TextField type="Lokasi" v-model="payload.location" label="Lokasi" />
        </div>
        <div class="mb-4 relative">
          <p class="text-base text-neutral-500 font-medium mb-1 block">Logo</p>
          <input type="file" nama="file" id="name" class="hidden" />
          <label for="name" class="border border-dashed p-6 rounded-md inline-block border-neutral-700 text-neutral-700 w-60 text-center cursor-pointer">Upload Image</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton')
  },
  data: () => ({
    payload: {
      name: '',
      location: '',
      email: ''
    }
  })
}
</script>
